import $ from 'jquery'
import { createApp } from '@app/adapters/create-app'

import SfSidepaneContentSwitcher from '@app/shared/vue/components/layout/sf-sidepane-content-switcher.vue'
import createStore from '@app/application/communication/sections/communication/store'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='sidepane']").each(function () {
    const data = $(this).data()
    const endpointParams = {
      contextType: data.contextType,
      contextId: data.contextId,
      contextHrefParam: data.contextHrefParam,
      ledgerId: data.ledgerId,
    }

    const sidepaneApp = createApp(SfSidepaneContentSwitcher, {
      contextId: data.contextId,
      contextType: data.contextType,
      ledgerLabel: data.ledgerLabel.toString(),
      onWorkflowReview: false,
      ownerId: data.ownerId,
      ownerType: data.ownerType,
      shouldRenderAuditLog: data.shouldRenderAuditLog,
    })

    sidepaneApp.use(createStore(endpointParams))

    sidepaneApp.mount(this)
  })
})
